// Turns the device's flat list of 160 numbers into 10 rows of 16.
// Data that is already in rows is returned as it is. Anything else returns null.
export const toMatrixRows = (matrix, columns = 16) => {
  if (!Array.isArray(matrix) || matrix.length === 0) return null;
  if (Array.isArray(matrix[0])) return matrix;
  if (matrix.length % columns !== 0) return null;
  const rows = [];
  for (let i = 0; i < matrix.length; i += columns) {
    rows.push(matrix.slice(i, i + columns));
  }
  return rows;
};
